module.exports = __webpack_public_path__ + "img/san_francisco_tramway.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/san_francisco_tramway.jpg
// module id = 6
// module chunks = 0